module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-bloc"
  }, [_c('div', {
    staticClass: "bloc bgc-white bg-bg-20version-202 d-bloc",
    attrs: {
      "id": "bloc-2"
    }
  }, [_c('div', {
    staticClass: "container bloc-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "mg-md tc-midnight-blue"
  }, [_vm._v("\n\t\t\t\t\t\tKilpailuta rakennusalan toimittajat vaivattomasti\n\t\t\t\t\t")]), _vm._v(" "), _c('h4', {
    staticClass: "mg-md tc-midnight-blue"
  }, [_vm._v("\n\t\t\t\t\t\tMe uskomme, että hyvin jäsennelty tieto johtaa parempiin päätöksiin.\n\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-midnight-blue",
    attrs: {
      "to": {
        name: 'projects.index'
      }
    }
  }, [_vm._v("Aloita kilpailuttaminen tästä")])], 1)])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bloc bgc-anti-flash-white d-bloc",
    attrs: {
      "id": "bloc-6"
    }
  }, [_c('div', {
    staticClass: "container bloc-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-midnight-blue",
    attrs: {
      "to": {
        name: 'projects.index'
      }
    }
  }, [_vm._v("Aloita kilpailuttaminen tästä")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc bgc-white l-bloc",
    attrs: {
      "id": "bloc-3"
    }
  }, [_c('div', {
    staticClass: "container bloc-lg"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "et-icon-pricetags front-icon icon-xl icon-midnight-blue"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "text-center mg-md"
  }, [_c('strong', [_vm._v("Kilpailuta")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center p"
  }, [_vm._v("\n\t\t\t\t\t\tOnko käynyt että et saanut kilpailukykyisiä tarjouksia? "), _c('br'), _vm._v("- Löydä projektillesi tehokkain ja luotettavin kumppani.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "et-icon-cloud front-icon icon-xl icon-midnight-blue"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "text-center mg-md"
  }, [_c('strong', [_vm._v("Keskitä")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\t\tOnko tärkeä sähköposti hukkunut? - Keskitä kaikki tiedonvaihto yhteen kanavaan kaikkien projektissa toimivien yritysten kesken.\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "et-icon-search front-icon icon-xl icon-midnight-blue"
  })]), _vm._v(" "), _c('h3', {
    staticClass: "text-center mg-md"
  }, [_c('strong', [_vm._v("Vertaile ja löydä")])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n\t\t\t\t\t\tMikä toimittajista on luotettavin, tehokkain tai edullisin? Ennen vertailu vei aikaa, mutta nyt vertailu tapahtuu vaivattomasti ja nopeasti.\n\t\t\t\t\t")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-30a7d5b3"}!./src/app/components/hero/hero.html
// module id = 467
// module chunks = 1